// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"DiagramTextSkeletonLoader_skeletonLoader__Jn-tO"};